import { Button, Icon } from "@components";
import { FC } from "react";
import { NavItemType } from "../useController";

interface MobileBotomTabProps {
    activeStack: string;
    navItems: NavItemType[];
    showLogout: boolean;
    onToggleLogout: ()=> void;
    onNavigateTo: (mavItem: NavItemType)=> void;
    onLogout: () => void;
}
export const MobileBotomTab: FC<MobileBotomTabProps> = ({ 
    activeStack,
    navItems,
    showLogout,
    onToggleLogout,
    onNavigateTo,
    onLogout,
}) => {

    return (
        <div
            className="fixed -bottom-1 left-0 w-full 
        bg-white text-white z-20 flex justify-between 
        items-center p-2 shadow-lg lg:hidden"
        >
            <div
                className={`flex flex-1 justify-around transition-all duration-300 
                ${showLogout
                        ? 'opacity-30 pointer-events-none'
                        : ''}`
                }
            >
                {
                    navItems.map((nav, i) => {
                        const isActive = nav.stack === activeStack;

                        if (nav.isHide) return null;
                        
                        return (
                            <div
                                key={i}
                                className={`flex flex-col items-center transition-all relative
                                    ${isActive
                                        ? 'text-secondary font-semibold'
                                        : 'text-primary'
                                    }
                                    ${nav.disabled
                                        ? 'opacity-50 cursor-not-allowed'
                                        : 'cursor-pointer'
                                    }`
                                }
                                onClick={() => onNavigateTo(nav)}
                            >
                                {nav.disabled && (
                                    <div
                                        className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"
                                    />
                                )}
                                <Icon iconName={nav.icon as any} size={24} />
                                <span className="text-xs">{nav.label}</span>
                            </div>
                        );
                    })
                }
            </div>

            <div className="relative flex items-center">
                <div
                    className={`absolute right-full transition-all duration-300 
                        ${showLogout
                            ? 'translate-x-0 opacity-100'
                            : 'translate-x-16 opacity-0'
                        }`
                    }
                >
                    {
                        showLogout && (
                            <Button
                                className="btn-secondary mr-2"
                                onClick={onLogout}
                            >
                                <Icon iconName="LogOut" size={24} />
                            </Button>
                        )
                    }
                </div>

                <div
                    className={
                        `p-1 rounded-full flex items-center
                         justify-center transition-all duration-300 
                         ${showLogout
                            ? 'bg-red-100 text-red-500'
                            : 'bg-gray-100 text-primary'
                        }`
                    }
                    onClick={onToggleLogout}
                >
                    <Icon
                        iconName={showLogout ? "ChevronRight" : "ChevronLeft"}
                        size={24}
                    />
                </div>
            </div>
        </div>
    )
}
